import React, { useEffect, useRef, useState } from 'react';
import AllTemplates from './allTemplates';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiServices from '../../../services/service';
import Loader from '../../../shared/component/Loader';

const TemplateGallery = () => {
  const location = useLocation();
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);

  const [selectedTab, setSelectedTab] = useState('');

  const scrollToSection = (id) => {
    const element = templateRefs.current?.[id]?.current;
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      // Adjust the scroll position slightly above center
      setTimeout(() => {
        const offset = -50; // Adjust this as needed
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300);
    }
  };

  useEffect(() => {
    if (templateList.length > 0) {
      const refs = {};
      templateList?.forEach((template) => {
        const key = template?.templateType?.replace(/\s+/g, '').toLowerCase();
        refs[key] = React.createRef();
      });
      templateRefs.current = refs;

      const firstKey = Object.keys(refs)[0];
      setSelectedTab(firstKey);
      setTimeout(() => scrollToSection(firstKey), 100); // short delay ensures DOM is ready
    }
  }, [templateList]);

  const templateRefs = useRef({});

  useEffect(() => {
    if (location.pathname.includes('templateGallery')) {
      if (location.state) {
        setModule(location.state);
      }
    }
  }, [location]);

  useEffect(() => {
    setLoading(true);
    if (module) {
      apiServices
        .getTemplateByModule(module)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            const data = response.data;

            // Generate refs dynamically
            const refs = {};
            data.forEach((template) => {
              const key = template.templateType.replace(/\s+/g, '').toLowerCase();
              refs[key] = React.createRef();
            });

            templateRefs.current = refs;
            setTemplateList(data);
          } else {
            setLoading(false);
            toast.error(`An unexpected error occurred: ${response.status}`, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching templates:', error);
          setLoading(false);
        });
    }
  }, [module]);

  return (
    <>
      {' '}
      {loading && <Loader />}
      <div className="ViewLeadPageOuter">
        <div className="viewFormContainer">
          <div className="leftBlock">
            <ul>
              {Object.keys(templateRefs.current).map((key) => (
                <li
                  key={key}
                  onClick={() => {
                    setSelectedTab(key);
                    scrollToSection(key);
                  }}
                  style={{ cursor: 'pointer' }}
                  className={`leftbox ${selectedTab === key ? 'activeList' : ''}`}
                >
                  <button style={{ fontWeight: 500 }}>
                    {key === 'aiagent'
                      ? 'AI Agent'
                      : key === 'digitaltransformation'
                        ? 'Digital Transformation'
                        : key.charAt(0).toUpperCase() + key.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="rightBlock">
            <div className="whiteBlock">
              {module && (
                <AllTemplates
                  module={module}
                  templateList={templateList}
                  templateRefs={templateRefs}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplateGallery;
